import { useCallback } from 'react';
import { ApiPermission } from '@allbin/mobilix-api-client';
import useUserStore from '../store/user';

interface PermissionsState {
  permissions: ApiPermission[];
  hasPermission: (permission: ApiPermission) => boolean;
}

const usePermissions = (): PermissionsState => {
  const { permissions } = useUserStore();

  const hasPermission = useCallback(
    (permission: ApiPermission): boolean => permissions.includes(permission),
    [permissions],
  );

  return { permissions, hasPermission };
};

export default usePermissions;
